import {
  daily_summary_overall,
  daily_summary_area,
  daily_summary_cluster,
  daily_summary_branch,
  daily_summary_branch_concurrent_request,
} from "../../services/reports/daily_summary_service";
import { actionTypes } from "../action_types";

const default_data = {
  branchCount: 0,
  totalPiecesDetail: {
    newPawn: 0,
    redeemedPawn: 0,
    active: 0,
    expired: 0,
  },
  totalPrincipalDetail: {
    newPawn: 0,
    redeemedPawn: 0,
    active: 0,
    expired: 0,
  },
  grossProfitDetail: {
    totalNewPawnCharges: 0,
    totalRedeemedPawnCharges: 0,
    totalCharges: 0,
  },
  totalPieces: 0,
  totalPrincipal: 0,
  averagePrincipalPerPiece: 0,
};

const createDailySummaryAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data !== null ? resp.data : default_data,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetDailySummaryOverall = createDailySummaryAction(
  daily_summary_overall,
  actionTypes.REPORTS_DAILY_SUMMARY_GET_OVERALL
);

export const GetDailySummaryCluster = createDailySummaryAction(
  daily_summary_cluster,
  actionTypes.REPORTS_DAILY_SUMMARY_GET_CLUSTER
);

export const GetDailySummaryArea = createDailySummaryAction(
  daily_summary_area,
  actionTypes.REPORTS_DAILY_SUMMARY_TARGET_GET_AREA
);

export const GetDailySummaryBranch = createDailySummaryAction(
  daily_summary_branch,
  actionTypes.REPORTS_DAILY_SUMMARY_TARGET_GET_BRANCH
);
export const GetDailySummaryBranchConcurrentRequest = createDailySummaryAction(
  daily_summary_branch_concurrent_request,
  actionTypes.REPORTS_DAILY_SUMMARY_TARGET_GET_BRANCH
);
